import React, {useEffect, useState, useRef, useMemo} from 'react';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import performanceService from '../../../services/data/performance.service';
import * as Yup from 'yup';
import companyService from '../../../services/data/company.service';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown';
import { useNavigate } from 'react-router-dom';
import { AutoComplete } from "primereact/autocomplete";
import employeeService from '../../../services/data/employee.service';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import TypeSteps from '../typeSteps';
import TypeStepsDueDates from '../typeStepsDueDates';
import PeerSelect from '../peerSelect';


export default function FormCreatePerformanceReviewAll() {
    
    const toast = useRef(null);

    // autocomplete
    const [search , setSearch] = useState('')
    const [items, setItems] = useState([])
    const [groupedItems, setGroupedItems] = useState([]) // para poder setar ao selecionar
    const [manager, setManager] = useState('')

    // autocomplete para pessoas fora da equipe
    const [searchOutsideTeam, setSearchOutsideTeam] = useState('')
    const [itemsOutsideTeam, setItemsOutsideTeam] = useState([])
    const [groupedItemsOutsideTeam, setGroupedItemsOutsideTeam] = useState([])
    const [selectedOutsideEmployee, setSelectedOutsideEmployee] = useState('')

    const [title] = useState('')
    const [startDate] = useState('')
    const [endDate] = useState('')
    const [status] = useState('AT')
    const [assessmentType, setAssessmentType] = useState('')
    const assessList = [
        //{ name: 'Plano de Desenvolvimento', code: 'PD' },
        { name: 'Avaliação 90º', code: 'BD' },
        { name: 'Avaliação 180º', code: 'AD' },
        { name: 'Avaliação 270º', code: 'SD' },
        { name: 'Avaliação 360º', code: 'TD' },
        { name: 'Reunião 1:1', code: 'RD' },
    ];
    
    const [employeeList, setEmployeeList] = useState() //lista para escolher
    const [employees, setEmployees] = useState('') // para ter o ID e buscar no emplist para ter tbm competencias
    const [employeesFinal, setEmployeesFinal] = useState([]) // para enviar pra API

    const [step, setStep] = useState(0)
    const [createdReview] = useState(null)
    const navigate = useNavigate();

    const [loadingList, setLoadingList] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitTimeout, setSubmitTimeout] = useState(null);

    const load = () => {
        // Validate form before proceeding
        const errors = formik.validateForm();
        
        errors.then((validationErrors) => {
            if (Object.keys(validationErrors).length > 0) {
                // Form has validation errors, don't proceed with submission
                formik.setTouched(validationErrors);
                toast.current.show({ 
                    severity: 'warn', 
                    summary: 'Campos obrigatórios', 
                    detail: 'Por favor, preencha todos os campos obrigatórios.', 
                    life: 4000 
                });
                return; // Exit early, don't start timeout or submission
            }
            
            // Form is valid, proceed with submission
            setLoading(true);
            
            // Clear any existing timeout
            if (submitTimeout) {
                clearTimeout(submitTimeout);
            }
            
            // Set a timeout for the form submission (30 seconds)
            const timeout = setTimeout(() => {
                setLoading(false);
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Timeout', 
                    detail: 'A operação demorou muito tempo. Tente novamente.', 
                    life: 5000 
                });
            }, 30000); // 30 seconds timeout
            
            setSubmitTimeout(timeout);
            formik.submitForm();
        });
    };

    // Cleanup timeout on component unmount
    useEffect(() => {
        return () => {
            if (submitTimeout) {
                clearTimeout(submitTimeout);
            }
        };
    }, [submitTimeout]);

    //auto complete gestor
    const searchItems = (event) => {
        if (event.query.length > 2) {

            setLoadingList(true)
            
            employeeService.autoCompleteEmployeeManager(event.query).then((response) => {
                let resultTitle = response.map((item) => item.user)
                setItems([...resultTitle])
                setGroupedItems(response.map((item) => item))

            })
            .catch((error) => {
                console.log(error.response.data)
            });
        }
    }

    function filterItems() {
        let filtered = groupedItems.find(x => x.user === search)
        setManager(filtered)
        setLoadingList(false)
    }

    function cleanSearch() {
        setSearch('')
        setManager('')
    }

    //auto complete para pessoas fora da equipe
    const searchItemsOutsideTeam = (event) => {
        if (event.query.length > 2) {
            setLoadingList(true)
            
            employeeService.autoCompleteEmployee(event.query).then((response) => {
                let resultTitle = response.map((item) => item.user)
                setItemsOutsideTeam([...resultTitle])
                setGroupedItemsOutsideTeam(response.map((item) => item))
            })
            .catch((error) => {
                console.log(error.response.data)
            });
        }
    }

    function filterItemsOutsideTeam() {
        let filtered = groupedItemsOutsideTeam.find(x => x.user === searchOutsideTeam)
        setSelectedOutsideEmployee(filtered)
        setLoadingList(false)
        
        // Adiciona automaticamente à equipe
        if (filtered) {
            addOutsideEmployeeToTeam(filtered)
        }
    }

    function cleanSearchOutsideTeam() {
        setSearchOutsideTeam('')
        setSelectedOutsideEmployee('')
    }

    function addOutsideEmployeeToTeam(employee = null) {
        const employeeToAdd = employee || selectedOutsideEmployee
        
        if (employeeToAdd) {
            const newEmployee = {
                name: employeeToAdd.user,
                value: employeeToAdd.id,
                internaljobtitle: employeeToAdd.internaljobtitle?.id || null,
                competencies: employeeToAdd.internaljobtitle?.competencies?.map((item) => item.id) || []
            }
            
            // Add to employeeList if not already present
            const existingEmployee = employeeList.find(emp => emp.value === newEmployee.value)
            if (!existingEmployee) {
                setEmployeeList(prev => [...prev, newEmployee])
            }
            
            // Add to employees selection if not already selected
            const isAlreadySelected = employees.includes(newEmployee.value)
            if (!isAlreadySelected) {
                setEmployees(prev => [...prev, newEmployee.value])
            }
            
            // Clear the search
            cleanSearchOutsideTeam()
        }
    }


    function listEmployees() {
        
        companyService.getUserTeamJobPosition(manager.id).then((response) => {    
            setEmployeeList(response.results.map((item) => {
                return {
                    name: `${item.user.first_name} ${item.user.last_name}`,
                    value: item.id,
                    internaljobtitle: item.jobposition.internaljobtitle.id,
                    competencies: item.jobposition.internaljobtitle.competencies.map((item) => item.id)
                }
            }))
        }).catch((error) => {
            console.log(error.response)
        });

    }

    useMemo(() => {
        if (employees) {

            let emp = employeeList.filter( (item) => {
                for (let i = 0; i < employees.length; i++) {
                    if (item.value === employees[i]) {
                        return item
                    }
                }
                return false
            })

            setEmployeesFinal(emp)
        }        
    }, [employees])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: title,
            start_date: startDate,
            end_date: endDate,
            status: status,
            assessment_type: assessmentType,
            result_to_matrix: true,
            steps_due_dates: null
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Favor preencher o campo Título"),
            start_date: Yup.date(),
            end_date: Yup.date().min(Yup.ref("start_date"), "Data de término tem de ser maior que a data de início"),
        }),
        onSubmit: values => {

            let data = {
                manager_id: manager.id,
                company_id: localStorage.getItem("companyId"),
                title: values.title,
                start_date: values.start_date,
                end_date: values.end_date,
                status: values.status,
                assessment_type: values.assessment_type.code,
                employee: employeesFinal,
                result_to_matrix: values.result_to_matrix,
                //and steps due dates
                steps_due_dates: values.steps_due_dates
            }

            performanceService.createPerformanceReview(data).then((response) => {
                // Clear the timeout since the request completed successfully
                if (submitTimeout) {
                    clearTimeout(submitTimeout);
                    setSubmitTimeout(null);
                }

                setLoading(false);
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: `${response.title} criado com sucesso`, life: 3000 });

                if (values.assessment_type.code === 'TD') {
                    // 360º: adicionar todos os pares automaticamente e navegar para o processo
                    performanceService.addAllPeerSteps(response.id).then(() => {
                        setTimeout(() => {
                            return navigate(`/performance-review/${response.id}/process/`)
                        }, 1000);
                    }).catch(() => {
                        // mesmo se falhar na criação dos pares, navega para o processo
                        setTimeout(() => {
                            return navigate(`/performance-review/${response.id}/process/`)
                        }, 1000);
                    });
                } else {
                    setTimeout(() => {
                        return navigate(`/performance-review/${response.id}/process/`)
                    }, 1500);
                }
                
            }).catch((error) => {
                // Clear the timeout since the request completed (with error)
                if (submitTimeout) {
                    clearTimeout(submitTimeout);
                    setSubmitTimeout(null);
                }
                
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data.detail, life: 4000 });
                setLoading(false);
            });

            
        },
    });

    return (
        <form onSubmit={formik.handleSubmit}>

            <Toast ref={toast} position="top-right" />

            {
                step === 0 ?
                // setar template
                <>
                <div className="col mb-3">
                    <label className="form-label fw-bold">Escolher Template <span className="text-danger">*</span></label>
                    <div className='p-inputgroup'>
                        <Dropdown placeholder="Selecionar" value={assessmentType} optionLabel="name" options={assessList} onChange={(e) => {setAssessmentType(e.value)} } className="rounded" />
                    </div>
                    <div className='mt-3'>
                        <TypeSteps type={assessmentType.code} />
                    </div>
                </div>
                {
                    assessmentType && step === 0?
                    <>
                    <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {setStep(1)}}>
                        Avançar
                    </span>
                    </>
                    : null
                }
                </>
                : null
            }
            {
                step === 1 ?
                // escolher manager
                <>
                    <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(0)}>
                        <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                    </span>
                    <p>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                    <div className="col mb-3">
                        <label className="form-label fw-bold mb-1">Selecionar Gestor <span className="text-danger">*</span></label>
                        <div className='row'>
                            <div className='col-md-9 px-0'>
                                <div className='p-inputgroup'>
                                    <AutoComplete inputClassName='input-search-radius' placeholder='Buscar Gestor pelo Nome' value={search} suggestions={items} completeMethod={searchItems} onChange={(e) => {setSearch(e.value); setLoadingList(false)}} />
                                    <span role='button' className='btn btn-success button-search-radius' onClick={filterItems}>
                                        <FontAwesomeIcon icon={solid('plus-circle')} />
                                    </span>
                                </div>
                            </div>
                            <div className='col'>
                            {
                                loadingList ?
                                <>
                                <ProgressSpinner style={{width: '30px', height: '30px'}} />
                                </>
                                :
                                null
                            }
                            {
                                manager ?
                                <button className='mt-1 btn btn-sm btn-link fw-bold font1em text-grey text-decoration-none' onClick={() => cleanSearch()}>
                                    Limpar
                                </button>
                                : null
                            }
                            </div>
                        </div>
                    </div>
                    {
                        manager ?
                        <>
                        <p>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                        <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {listEmployees(); setStep(2)}}>
                            Avançar
                        </span>
                        </>
                        : null
                    }
                </>
                :
                null
            }
            
            {
                step === 2 ?
                <>
                {
                    employeeList && employeeList.length > 0 ?
                    <>
                    <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(1)}>
                        <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                    </span>
                    <p className='mb-0'>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                    <p>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                    <div className="col mb-3">
                        <label className="form-label fw-bold mb-0">Enviar para <span className="text-danger">*</span></label>
                        <p className='mb-1'>Selecionar pessoa da equipe</p>
                        <div className='row'>
                            <div className='col-md-9 px-0'>
                                <div className='p-inputgroup'>
                                    <MultiSelect filter optionLabel="name" placeholder="Selecionar" value={employees} onChange={(e) => setEmployees(e.value)} options={employeeList} display="chip" className="rounded" />
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                    :
                    <p>Carregando equipe</p>
                }

                <div className="col mb-3">
                    <label className="form-label fw-bold mb-0">Incluir pessoa fora da equipe</label>
                    <p className='mb-1'>Selecionar pessoa fora da equipe</p>
                    <div className='row'>
                        <div className='col-md-9 px-0'>
                            <div className='p-inputgroup'>
                                <AutoComplete 
                                    inputClassName='input-search-radius' 
                                    placeholder='Buscar Nome' 
                                    value={searchOutsideTeam} 
                                    suggestions={itemsOutsideTeam} 
                                    completeMethod={searchItemsOutsideTeam} 
                                    onChange={(e) => {setSearchOutsideTeam(e.value); setLoadingList(false)}} 
                                />
                                <span role='button' className='btn btn-success button-search-radius' onClick={filterItemsOutsideTeam}>
                                    <FontAwesomeIcon icon={solid('plus-circle')} />
                                </span>
                            </div>
                        </div>
                        <div className='col'>
                        {
                            loadingList ?
                            <>
                            <ProgressSpinner style={{width: '30px', height: '30px'}} />
                            </>
                            :
                            null
                        }
                        {
                            selectedOutsideEmployee ?
                            <button className='mt-1 btn btn-sm btn-link fw-bold font1em text-grey text-decoration-none' onClick={() => cleanSearchOutsideTeam()}>
                                Limpar
                            </button>
                            : null
                        }
                        </div>
                    </div>
                    {
                        selectedOutsideEmployee ?
                        <>
                        <p className='mt-2 text-success'><FontAwesomeIcon icon={solid('check-circle')} /> Pessoa adicionada automaticamente à equipe</p>
                        </>
                        : null
                    }
                </div>
                {
                    employees ?
                    <>
                    {
                        employees.length > 1 ?
                        <p>Enviando para <span className='fw-bold'>{employees.length}</span> pessoas</p>
                        : null
                    }
                    <span className='btn btn-success btn-sm btn-rounded px-4' onClick={() => {setStep(3)}}>
                        Avançar
                    </span>
                    </>
                    : null
                }
                </>
                :
                null
            }
            {
                step === 3 ?
                <>
                <span role="button" className="nav-link mt-2 mb-3" onClick={() => setStep(2)}>
                    <span className="text-green fw-bold"><FontAwesomeIcon icon={solid('chevron-left')} /> Voltar</span>
                </span>
                <p className='mb-0'>Template: <span className='fw-bold'>{assessmentType.name}</span></p>
                <p className='mb-0'>Gestor: <span className='fw-bold'>{manager.user}</span></p>
                <p>Enviando para <span className='fw-bold'>{employees.length}</span> pessoas</p>
                <div className="col mb-3">
                    <label className="form-label fw-bold">Título <span className="text-danger">*</span></label>
                    <input name='title' type="text" className="form-control text-capitalize" placeholder='Avaliação de Desempenho Semetral' required {...formik.getFieldProps('title')} />
                </div>

                <div className='row mb-4 px-0'>
                    <div className='col'>
                        <label className="form-label fw-bold">Data de Início <span className="text-danger">*</span></label>
                        <input className="form-control" name='start_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('start_date')} />
                        {formik.errors.start_date ? (<span name="start_date" className="text-vermelho">{formik.errors.start_date}</span>) : null}
                    </div>

                    <div className='col'>
                        <label className="form-label fw-bold">Data de Término <span className="text-danger">*</span></label>
                        <input className="form-control" name='end_date' type="date" required="required" autoComplete="off" {...formik.getFieldProps('end_date')} />
                        {formik.errors.end_date ? (<span name="end_date" className="text-vermelho">{formik.errors.end_date}</span>) : null}
                    </div>
                </div>

                <div className='row mb-4 px-0'>
                    <TypeStepsDueDates 
                        type={assessmentType.code} 
                        start_date={formik.values.start_date} 
                        end_date={formik.values.end_date}
                        onChangeSteps={(steps) => formik.setFieldValue('steps_due_dates', (steps && steps.length > 0) ? steps : null)}
                    />
                </div>

                <div className="form-check form-switch mb-4">
                    <label className="form-switch-label">Considerar Resultado na Matriz 9Box?</label>
                    <input className="form-check-input" type="checkbox" role="switch" name='result_to_matrix' aria-checked={formik.values.result_to_matrix} checked={formik.values.result_to_matrix} {...formik.getFieldProps('result_to_matrix')} />
                </div>

                <div className="d-grid mx-auto btnMargin">
                    <Button rounded label="Criar" type='submit' icon="pi pi-check" loading={loading} onClick={load} />
                </div>
                </>
                : null
            }
            {
                step === 4 && createdReview ?
                <>
                <p className='fs-6 fw-bold mb-1'>Avaliação 360º criada com sucesso!</p>
                <p className='text-muted small mb-3'>
                    Defina quais colaboradores irão avaliar cada avaliado como pares. Você também pode configurar os pares depois, na página da avaliação.
                </p>
                <PeerSelect
                    participants={[createdReview]}
                />
                <div className='mt-4'>
                    <button
                        type='button'
                        className='btn btn-success btn-rounded px-4'
                        onClick={() => navigate(`/performance-review/${createdReview.id}/process/`)}
                    >
                        Concluir
                    </button>
                </div>
                </>
                : null
            }
        </form>
    )
}